import PropTypes from "prop-types";
import { Box } from "@mui/material";

const BG = "rgba(120,120,120,0.9)";

// Round front/back camera switch. Shown only before a scan starts.
export const CameraSwitchButton = (props) => {
  const { onClick } = props;
  return (
    <Box
      component="button"
      type="button"
      aria-label="Switch camera"
      onClick={onClick}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "none",
        p: 0,
        cursor: "pointer",
        backgroundColor: BG,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24">
        {/* camera body */}
        <path
          fill="#fff"
          d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"
        />
        {/* rotate arrows carved out of the lens */}
        <g fill="none" stroke={BG} strokeWidth="1.4" strokeLinecap="round">
          <path d="M9.3 12.1a3 3 0 0 1 5.1-1.2" />
          <path d="M14.7 13.9a3 3 0 0 1-5.1 1.2" />
        </g>
        <g fill="#fff">
          <path d="M14.7 9.2l0.2 2.0-2.0-0.3z" />
          <path d="M9.3 16.8l-0.2-2.0 2.0 0.3z" />
        </g>
      </svg>
    </Box>
  );
};

CameraSwitchButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
